import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import ComboBox from '../ComboBox';
import SwitchIcon from '../../assets/images/switch-icon.svg';
import Button from '../Buttons/DialogButton';
import LoadingDots from '../../components/LoadingDots';
import Animate from '../../components/Animate';
import dataModel from '../../models/DataModel';

import './SwitchCompany.scss';
import { resetUserState } from '../../models';

export class SwitchCompany extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      companySelected: (this.props.currentCompany ? { type: this.props.currentCompany.id, name: this.props.currentCompany.name } : null),
    };
    this.handleCompanySelect = this.handleCompanySelect.bind(this);
  }

  componentDidMount() {
    this.backgroundElement = document.getElementById('popup-background');
    if (this.backgroundElement) {
      this.backgroundElement.addEventListener('click', this.handleCancel);
    }
  }

  componentDidUpdate(prevProps) {

  }

  componentWillUnmount() {
    if (this.backgroundElement) {
      this.backgroundElement.removeEventListener('click', this.handleCancel);
    }
  }

  createCompanyOptions() {
    let companyList = [];
    const { companies } = this.props;
    if (companies) {
      companyList = companies.map(company => {
        return { type: company.id, name: company.name };
      });

      companyList.sort((c1, c2) => {
        if (c1.name.toLowerCase() < c2.name.toLowerCase()) {
          return -1;
        }
        else if (c1.name.toLowerCase() > c2.name.toLowerCase()) {
          return 1;
        }
        else {
          return 0;
        }
      });
    }
    return companyList;
  }

  handleCompanyChange(type, option){
    const { companies } = this.props;
    let company = companies.filter(function(company){
      return company.name == option.name;
    });
    company = company[0];
    this.setState({
      companySelected: company,
    });
  }

  handleCompanySelect() {
    this.setState({ animateClose: true });
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
    if (this.state.companySelected && this.state.companySelected.id != this.props.currentCompany.id) {
      const { companySelected } = this.state;
      const { currentUser } = this.props;

      dataModel.companiesDAO.getCurrentCompany(companySelected.id).then(fetchedCompany => {
        if (fetchedCompany) {
          this.props.resetUserState();
          //set edit permissions - company admins can edit their primary company, and super users can edit all companies
          if (fetchedCompany && (currentUser.super_admin || (currentUser.role.name == 'admin' && +localStorage.primary_company_id == fetchedCompany.id))) {
            dataModel.companiesDAO.setCompanyReadOnly(fetchedCompany, false);
          }
          else {
            dataModel.companiesDAO.setCompanyReadOnly(fetchedCompany, true);
          }
          dataModel.companiesDAO.setCurrentCompany(fetchedCompany);
          this.props.dataModel.hideGlobalBanner();
          // set companySelected on data model
          if (currentUser.super_admin) {
            this.props.history.replace('/projects/summary');
          }
          else if (currentUser.companies && currentUser.companies.length && currentUser.companies[0].id == fetchedCompany.id && currentUser.role_name != 'standard_user') {
            this.props.history.replace('/projects/summary');
          }
          else {
            this.props.history.replace('/tasks/project/all');
          }
        }
      });
    }
  }

  handleCancel(){
    this.setState({ animateClose: true });
  }

  handleAnimationClose() {
    this.setState({ animateClose: true });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      if (this.state.companySelected) {
        this.handleCompanySelect();
      }
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleCancel();
    }
  }

  render() {
    let { height, width, hasBorder, defaultText, displayFontStyle, currentCompany, maxHeight, top, left, label, tabIndex,
      makeAbsolute, underlined, menuHeight } = this.props;

    let currentOption = this.state.companySelected ? { type: this.state.companySelected.type, name: this.state.companySelected.name } : { type: currentCompany.id, name: currentCompany.name };
    let options = this.createCompanyOptions();

    return (
      <div className="switch-company-container" id="switch-company-container" onKeyDown={this.handleKeyDown} ref={(element) => { this.root = element; }}>
        <Animate key="animate-switch-company-in" component_id="switch-company-container" duration={150} property={{
          width: {
            startVal: 0,
            endVal: 270,
          },
        }} />
        {this.state.animateClose && (
          <Animate key="animate-switch-company-out" component_id="switch-company-container" duration={150} property={{
            width: {
              startVal: 270,
              endVal: 0,
            },
          }} completionCallback={this.handleAnimationClose} />
        )}
        <div className='switch-company-label'>
            <img className='switch-company-icon'src={SwitchIcon} alt='switch'/>
            <span className='switch-company-title'>{this.textMap.switchCompany}</span>
        </div>
        <div className='switch-company-combobox-container'>
            <span className='switch-company-combobox-label'>{this.textMap.selectCompany.toUpperCase()}</span>
            <div className='switch-company-combobox'>
            <ComboBox id={'switchCompany'} options={options} height={height} width={width} hasBorder={hasBorder} defaultText={defaultText}
              currentOption={currentOption} displayFontStyle={displayFontStyle} handleSelection={this.handleCompanyChange}
              maxHeight={maxHeight} top={top} left={left} makeAbsolute={makeAbsolute} label={label} underlined={underlined}
              tabIndex={tabIndex} menuHeight={menuHeight}n disabled={this.props.loadingCompanies}
                />
              { this.props.loadingCompanies && <LoadingDots/>}
            </div>
        </div>
        <div className='button-container'>
            <Button width={106} height={20} text="Cancel" 
                position="absolute" bottom={19} left={24} 
                fontStyle={{ color: '#ffffff', fontFamily: 'Open Sans', fontSize: '12px', letterSpacing: '0px', lineHeight: '20px' }} 
                fill='#BCBEC0'
                handleClick={this.handleCancel}/>
            <Button width={106} height={20} text="Select Company" 
                position="absolute" bottom={19} left={137} 
                fontStyle={{ color: '#ffffff', fontFamily: 'Open Sans', fontSize: '12px', letterSpacing: '0px', lineHeight: '20px' }} 
                fill='#CD030A'
                handleClick={this.handleCompanySelect}/>
        </div>
    </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetUserState: () => dispatch(resetUserState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SwitchCompany));



// WEBPACK FOOTER //
// ./src/components/SwitchCompany/index.js